package app.smartcoding.realrate.presentation

import androidx.compose.runtime.Stable
import androidx.compose.runtime.derivedStateOf
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.setValue
import androidx.lifecycle.ViewModel
import app.smartcoding.realrate.domain.model.AuthUser
import app.smartcoding.realrate.domain.model.LanguageCode
import app.smartcoding.realrate.domain.model.SettingsState
import app.smartcoding.realrate.domain.model.ThemeOption
import app.smartcoding.realrate.platform.loadUserSettings
import app.smartcoding.realrate.platform.saveUserSettings

@Stable
class SettingsViewModel(
    authUser: AuthUser,
    isSystemInDarkTheme: Boolean,
    languageCode: LanguageCode
) : ViewModel() {
    private var authUser: AuthUser by mutableStateOf(authUser)

    var settings by mutableStateOf(
        SettingsState(
            theme = ThemeOption.SYSTEM,
            languageCode = languageCode
        )
    )
        private set

    var isSystemInDarkTheme by mutableStateOf(isSystemInDarkTheme)
        private set

    val isDarkTheme: Boolean by derivedStateOf {
        when (settings.theme) {
            ThemeOption.DARK -> true
            ThemeOption.LIGHT -> false
            ThemeOption.SYSTEM -> this@SettingsViewModel.isSystemInDarkTheme
        }
    }
    var showAds by mutableStateOf(false)
        private set

    suspend fun loadSettings(authUser: AuthUser) {
        when (authUser) {
            AuthUser.Unknown -> {
                println("Unknown user")
            }
            is AuthUser.User -> {
//                println("Loading settings for user ${authUser.uid} ${authUser.email}")
                loadUserSettings(
                    authUser = authUser,
                    onSuccess = { settings ->
                        println("Loaded settings success $settings")
                        this@SettingsViewModel.settings = settings
                    },
                    onFailed = { e ->
                        println("Failed to load settings ${e.message}")
                    }
                )
            }
        }
    }

    suspend fun onThemeSelected(newTheme: ThemeOption) {
        settings = settings.copy(theme = newTheme)
        when (val user = authUser) {
            AuthUser.Unknown -> {}
            is AuthUser.User -> {
                saveUserSettings(
                    authUser = user,
                    settings = settings,
                    onSuccess = {},
                    onFailed = { e -> println("Failed to save settings ${e.message}") }
                )
            }
        }
    }

    suspend fun onLanguageCodeSelected(code: LanguageCode) {
        settings = settings.copy(languageCode = code)
        when (val user = authUser) {
            AuthUser.Unknown -> {}
            is AuthUser.User -> {
                saveUserSettings(
                    authUser = user,
                    settings = settings,
                    onSuccess = {},
                    onFailed = { e -> println("Failed to save settings ${e.message}") }
                )
            }
        }
    }

    fun showAds(showAds: Boolean) {
        this@SettingsViewModel.showAds = showAds
    }

    fun onSystemThemeChanged(systemInDarkTheme: Boolean) {
        isSystemInDarkTheme = systemInDarkTheme
    }

    suspend fun setAuthUser(authUser: AuthUser) {
        this.authUser = authUser
        loadSettings(authUser)
    }
}